<template>
  <DpplDarkTooltip
    v-if="tooltip.body_r"
    :tooltip-placement="tooltipPlacement"
    :tooltip-offset="tooltipOffset"
    :multiple-tooltip-offsets="multipleTooltipOffsets"
    :max-width="maxWidth"
    light-mode
  >
    <template #activator="{ onMouseenter, onMouseleave }">
      <v-icon
        color="iconDefault"
        size="18px"
        icon="$information-outline"
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
      />
    </template>
    <template #tooltip-content>
      <div class="tooltip-content">
        <strong v-if="tooltip.title">{{ tooltip.title }}<br></strong>
        <div class="tooltip-html" @click.stop>
          <DpplSafeHtml :html="tooltip.body_r" />
        </div>
      </div>
    </template>
  </DpplDarkTooltip>
</template>

<script setup>
import DpplDarkTooltip from '@/components/datapeople/DpplDarkTooltip.vue';
import DpplSafeHtml from '@ui/components/general/DpplSafeHtml/DpplSafeHtml.vue';

defineProps({
  tooltip: {
    type: Object,
    default: () => ({}),
  },
  tooltipPlacement: {
    type: String,
    default: 'right',
  },
  maxWidth: {
    type: String,
    default: '252px',
  },
  tooltipOffset: {
    type: Number,
    default: 12,
  },
  multipleTooltipOffsets: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="less" scoped>
:deep(.activator) {
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.tooltip-html) {
  font-size: 13px;
  font-weight: 500;

  p {
    font-size: 13px;
    font-weight: 500;
    color: @text-dark;
  }

  a {
    font-size: 13px;
    font-weight: 500;
    color: @text-brand;
  }
}
</style>
